<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar :variant="variant" :size="32" name="AV" class="me-75 flex-shrink-0" v-if="!avatar">
        <!-- <i class="fa-solid " :class="icon"></i> -->
        <font-awesome-icon :icon="['fas', icon]" color="white" />
      </b-avatar>
      <avatar :size="44" :src="avatarSrc" class="me-75 flex-shrink-0" name="AV" v-else />
      <div class="d-flex flex-grow-1">
        <div>
          <h5 v-if="title" class="mb-0 font-weight-bolder toastification-title" :class="`text-${variant}`"
            v-text="title" />
          <small v-if="text" class="d-inline-block text-body" v-text="text" />
        </div>
        <span class="cursor-pointer toastification-close-icon ms-auto " @click="$emit('close-toast')">
          <!-- <font-awesome-icon icon="fas fa-times" /> -->
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
  },
  icon: {
    type: [String, null],
    default: null,
  },
  title: {
    type: [String,null],
    default: null,
  },
  text: {
    type: [String, null],
    default: null,
  },
  hideClose: {
    type: Boolean,
    default: false,
  },
  avatar:{
    type:Boolean,
    default:false,
  },
  avatarSrc:{
    type:String,
    required:false,
  }
});


</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
